import {LitElement, html, css} from 'lit';
import {msg} from '@lit/localize';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {selectProductModelId} from '../../../selectors';
import {luminaryOptions} from '../../lightProfileSectionConfig';



@customElement('visual-lightprofile-luminary')
export class VisualLightprofileLuminary extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
		}

		.container {
			display: flex;
			gap: 10px;
			flex-direction: column;
			align-items: center;
		}

		h1 {
			font: var(--font-big-title);
			color: var(--color-grey3);
			margin-bottom: 0;
		}

		pre {
			font: var(--font-light);
			color: var(--color-grey3);
			width: 600px;
			height: 600px;
			overflow: scroll;
		}

		p {
			font: var(--font-light);
			color: var(--color-grey3);
		}

		.luminaryInfo {
			position: absolute;
			bottom: var(--large-padding);
			left: var(--large-padding);
			right: var(--large-padding);
		}

		.luminaryProfileImg {
			margin: auto;
			left: 50%;
			position: absolute;
			bottom: 55%;
		}


		.title {
			font: var(--font-small-title);
			color: var(--color-white);
			margin-bottom: 0;
			border-bottom: 1px solid grey;
			padding-bottom: 20px;
		}

		.info {
			color: var(--color-white);
			font: var(--font-info-light);
			line-height: 30px;
			height: 100px;
			width: 55%;
		}

		.moreInfo {
			color: var(--color-white);
			font: var(--font-summary-table);
			line-height: 30px;
			padding: 10px 15px;
			text-decoration: none;
			border: 1px solid var(--color-white);
			float: right;
			position: absolute;
			right: 0px;
			top: 140px;
		}

		.desktop-only {
			display: block;
		}

		@media (min-width: 768px) {
			.luminaryInfo {
				margin-left: 350px;
			}

			.luminaryProfileImg {
				left: calc(42vw - 320px);
				margin: 0;
				height: calc(80vh - 150px);
				position: absolute;
				bottom: 150px;
				z-index: -1;
			}
		}
		@media (max-width: 768px) {
			.desktop-only {
				display: none;
			}

			.luminaryProfileImg {
				margin: auto;
				left: 25%;
				position: absolute;
				height: 50vw;
			}
		}
    `;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());

	}

	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
		this.lang = state.status.lang;
		this.luminary = luminaryOptions.find(luminary => luminary.id === this.lightProfile.project.luminary);
	}

	render() {
		if (!this.luminary) return null;
		const s = this.state;
		let imageSrc = '';
		if (this.luminary.hasOwnProperty('imageModelSpecific')) {
			imageSrc = this.luminary.imageModelSpecific[selectProductModelId(s)].image;
		} else {
			imageSrc = this.luminary.image;
		}
		return html`
			<div class="container">
				<div class="luminaryProfile">
					<div class="luminaryInfo">
						${when(this.luminary !== undefined, () => html`
							<img class="luminaryProfileImg" src="${imageSrc}" alt=""/>
							<h1 class="title desktop-only">${this.luminary.label[this.lang]}</h1>
							<p class="info desktop-only">${this.luminary.description[this.lang]}</p>
							<a href="" class="moreInfo desktop-only">${msg('More information')}</a>
						`)}
					</div>
				</div>
		`;
	}
}
